import { create } from 'zustand'

interface IUnitSettingsStore {
  open: boolean
  setOpen: (open: boolean) => void
}

export const useUnitSettingsStore = create<IUnitSettingsStore>((set) => ({
  open: false,
  setOpen: (open: boolean) => set(() => ({ open }))
}))
